import React from 'react';
import { FaDownload, FaExternalLinkAlt } from 'react-icons/fa';

import { formatBytes } from '../../utils/projectUtils';
import { clsx } from '../../utils/utils';
import * as styles from './FileRow.module.scss';

export interface FileRowProps {
  title: string;
  description?: string;
  size?: number;
  fileUrl?: string;
  link?: string;
  className?: string;
  withFileBorder?: boolean;
  withParagraphFont?: boolean;
  onDownloadClick?: ((url: string) => void) | null;
}

const FileRow = ({
  title,
  className,
  description,
  size,
  fileUrl,
  link,
  onDownloadClick,
}: FileRowProps): React.ReactElement => {
  const fileDownloadUrl = fileUrl + '?dl';

  return (
    <div className={clsx(styles.file, className)}>
      <div className={clsx(styles.titleContent)}>
        <h4 className={styles.fileTitle} title={title}>
          {title}
        </h4>
      </div>
      <div className={styles.infoContainer}>
        {description && <span className={styles.fileDescription}>{description}</span>}
        <div className={styles.fileDetailsContainer}>
          {fileUrl && (
            <>
              <span className={styles.fileSize}>
                {size !== undefined ? formatBytes(size, 0) : '---'}
              </span>
              <span className={styles.fileSizeDecimal}>
                {size !== undefined ? formatBytes(size, 1) : '---'}
              </span>
            </>
          )}

          <div className={styles.fileLinks}>
            {fileUrl && (
              <a
                href={!onDownloadClick ? fileDownloadUrl : undefined}
                onClick={
                  onDownloadClick
                    ? () => {
                        onDownloadClick(fileDownloadUrl);
                      }
                    : undefined
                }
              >
                <FaDownload className={styles.icon} />
              </a>
            )}
            <a href={fileUrl || link} target="_blank" rel="noopener noreferrer">
              <FaExternalLinkAlt className={styles.icon} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileRow;
